
<div id="main-wrapper">
    <div class="site-wrapper-reveal personalise_content">
        <div class="blog-pages-wrapper section-space--ptb_90">
            <div class="row">
                <div class="col-lg-1"></div>
                <!--====== Blogs Sidecolumns Start ======-->
                <div class="col-lg-4 order-lg-2 order-2">
                    <div class="page-sidebar-content-wrapper page-sidebar-right small-mt__40 tablet-mt__40">
                        <!--====== Blogs Recent Post start ======-->
                        <div
                            class="sidebar-widget blog_sidebarwidget  widgeglobal_section_contentt-blog-recent-post blog_widgetpost wow blog_moveupsidebar move-up">
                            <div class="blog_posttilte sidebar-widget-title global_section_header" role="heading">Recent Posts</div>
                            <ul class="blog_ulpost">
                                <li class="blog_lipost">
                                    <a href="/personalize-and-machine-learning"
                                        class="blog_listanchortags global_section_content">Personalisation and Machine
                                        Learning in Marketing</a>
                                </li>
                                <li class="blog_lipost">
                                    <a href="/postpandamic" class="blog_listanchortags global_section_content">The new
                                        wave of Digital Marketing in the Post-Pandemic world</a>
                                </li>
                                <li class="blog_lipost">
                                    <a href="/migrate-cloud" class="blog_listanchortags global_section_content">Why is
                                        cloud migration critical in the covid-19 scenario</a>
                                </li>
                                <li class="blog_lipost">
                                    <a href="/digital-partner" class="blog_listanchortags global_section_content">How to
                                        choose your digital partner?</a>
                                </li>
                                <li class="blog_lipost">
                                    <a href="/cyber-security"
                                        class="blog_listanchortags global_section_content">Importance of Cybersecurity
                                        in Business Growth</a>
                                </li>
                            </ul>
                        </div>

                        <!--====== Blogs Recent Post end ======-->




                        <!--====== Blogs Sidebar Widget Start ======-->

                        <!--====== Blogs Sidebar Widget End ======-->
                    </div>
                </div>
                <!--====== Blogs Sidecolumns End ======-->


                <!--====== Blogs Middele columns Start ======-->

                <div class="col-lg-7 order-lg-1 order-1">
                    <div class="main-blog-wrap">
                        <div class="single-blog-item">


                            <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                               
                            </div>
                            <div class="post-info lg-blog-post-info  wow  blog_moveupsidebar move-up">

                                <div class="post-title global_section_header" role="heading">What is an H1B Visa?</div>
                                <div class="post-meta mt-20">
                                    <div class="post-author">

                                        <!-- <span class="meta-icon"> <i class="fa fa-book"></i></span> -->
                                    </div>
                                    <div class="post-date">                               
                                        <span class="meta-icon"><i class="fa-regular fa-calendar-days"></i></span>

                                        November 11, 2022
                                    </div>
                                    <div class="post-view">   
                                      <span class="meta-icon"> <i class=" fa-solid fa-eye"></i></span>

                                        320 views
                                    </div>
                                    <div class="post-read view-item2">
                                        <i class="fa fa-book"></i>
                                          3 min Read 
                                      </div> 
                                </div>

                                <div class="blogs_subparacontent  blog_content text-black">
                                    <p class="global_section_content  pt-4">Generally known as a work visa, H-1B is a
                                        non-immigrant employment-based visa provided to an eligible temporary worker.
                                        The H-1B visa allows a foreign national to work in the United States for a
                                        temporary period. The H-1B visa is nominated for individuals working in a
                                        specialty occupation. A specialty occupation is defined as the position
                                        demanding at least a bachelor’s degree in a precise or related field (or its
                                        equivalent).
                                    </p>



                                    <blockquote>

                                        <p class="pt-2 global_section_content pt-4">
                                            85,000 H1B visas are available each fiscal year. Out of these 85,000, 20,000
                                            visas are restricted to individuals who have received master’s degrees or
                                            higher from U.S colleges or universities.
                                        </p>
                                    </blockquote>
                                    <div class="mt-5">

                                        <p class="pt-2 global_section_content pt-4">
                                            H-1B visa is issued to the specialty occupation fields like Information
                                            Technology, Computer Science, Engineering, Mathematics, Management many more
                                            (these are just a few examples). To be eligible for this visa category, it
                                            also requires that the foreign national has at least a bachelor’s degree in
                                            that specific or related field (or its equivalent). The salary for the
                                            position must meet minimum prevailing wage requirements.
                                        </p>
                                    </div>

                                    <div class="mt-5">
                                        <div class="global_section_header">Period of Stay in H-1B Visa</div>
                                        <p class="pt-4 global_section_content">
                                            The initial period of stay for an H-1B visa holder in the U.S. is typically
                                            three years. Visa can be extended for 3 more years. The total period of stay
                                            should not exceed 6 years. There are few exceptions available where an H1B
                                            visa can be extended beyond 6 years which allows the H-1B visa holder to
                                            continue to stay and work in the USA. Want to know more about the step by
                                            step process, reach us at immigration&#64;mitresource.com
                                        </p>
                                    </div>



                                    <div class="entry-author">
                                        <div class="author-info">
                                            <div class="author-avatar">
                                                <img src="../../../assets/images/blogs/owen_christimage.png"
                                                    class="" alt="blogs owenchrist" />
                                            </div>
                                            <div class="author-description">
                                                <h6 class="author-name global_section_header">Gita Poudel</h6>
                                                <div class="author-biographical-info global_section_content">
                                                    Sr. HR & Compliance Manager
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <!--====== Blogs Application Form Start ======-->


                                    <!--====== Blogs Application Form End ======-->
                                </div>

                            </div>


                        </div>
                    </div>
                </div>
                <!--====== Blogs Middele columns End ======-->

            </div>
        </div>
    </div>
</div>

